<!-- <form (ngSubmit)="SaveItem()" #f="ngForm" class="mt-4 pl-2"> -->
<form [formGroup]="baseFormGroup" #f="ngForm" class="mt-4 pl-2">
  <div class="form-horizontal">
    <div class="row">
      <div class="col-md-12">
        
        <div class="form-group row">
          <!-- <label class="col-form-label col-2"><span translate="ROBNAGRUPA.NAZIV.SINGULAR"></span></label> -->
          <div class="col-md-12">
            <!-- <input
              type="text"
              name="txtNaziv"
              class="form-control"
              [(ngModel)]="Item.Naziv"
              autofocus
              required
              maxlength="200"
              #Naziv="ngModel"> -->
            <yt-input
              [Type]="'text'"
              formControlName="Naziv"
              [ngClass]="{'is-invalid': submitted && fc.Naziv.invalid}"
              [Label]="'ROBNAGRUPA.NAZIV.SINGULAR'">
            </yt-input>
          </div>
        </div>
        <div class="form-group row">
          <!-- <label class="col-form-label col-2"><span translate="ROBNAGRUPA.SINGULAR"></span></label> -->
          <div class="col-md-12">
              <!-- <yt-fw-dropdown
              [ModelName]="'robnagrupa'"
              [GetName]="'get'"
              [ModelProperty]="'Naziv'"
              [OrderBy]="'Naziv'"
              [AllowAddNew]='true'
              [Required]='true'
              [Disabled]='false'
              [(ngModel)]="Item.TataID"
              name="cmbRobnaGrupa"
              [Type]="ID">
            </yt-fw-dropdown> -->
            <yt-dropdown-picklist
              [ModelName]="'robnagrupa'"
              [GetName]="'getRoot'"
              [ModelProperty]="'Naziv'"
              [OrderBy]="'Naziv'"
              [AllowAddNew]="false"
              formControlName="TataID"
              [Label]="'ROBNAGRUPA.TATAID.SINGULAR'"
              [Type]="'treeview'"
              [Required]="false"
              >
            </yt-dropdown-picklist>
          </div>
        </div>
        
      </div>
    </div>
  </div>
</form>